import React, {Component} from 'react'
import ClassNames from 'classnames'
import ga from 'react-ga'
import ReactPixel from 'react-facebook-pixel'
import UserStore from 'stores/UserStore'
import GeneralStore from 'stores/GeneralStore'
import InstantBookingStore from 'stores/InstantBookingStore'
import ActionCreators from 'actions/ActionCreators'
import {createControlFactory} from 'components/Controls'
import Switch from 'components/SwitchControl'
import Button from 'components/ButtonControl'
import IconControl from 'components/IconControl'
import CheckboxControl from 'components/CheckboxControl'
import ProgressBarPane from 'components/ProgressBarPane'
import IconSVG from 'svg-inline-react'
import SocialAuthDialog from 'components/SocialAuthDialog'
import RestorePasswordDialog from 'components/RestorePasswordDialog'
import TelControl from 'components/TelControl';
import {translate as t} from 'lang'
import {dumpState} from 'api'

import './ContactsScreen.scss'

const CONTACTS_SCREEN_PROGRESS_BAR_CONFIG = [true, true, true, true, true]
const LEFT_BUTTON_ARROW = <IconControl name="leftArrow"/>

function getStateFromStores() {
    return {
        user: UserStore.getUser(),
        showInstantBooking: InstantBookingStore.showInstantBooking(),
        isIsraelModeOn: GeneralStore.isIsraelModeOn(),
    }
}

class ContactsScreen extends Component {

    state = {
        ...getStateFromStores(),
        hasAdditionalPhone: false,
        showSocialAuthDialog: false,
        showRestorePasswordDialog: false,
        socialAuthType: '',
        agree: false,
        isPhoneOrMail: false,
        phoneErrors: '',
        phoneAuth: '',
    }

    componentDidMount() {
        UserStore.addChangeListener(this._onChange)
        ActionCreators.cancelTankmenValidation()
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this._onChange)
    }

    _onChange = () => {
        this.setState(getStateFromStores())
    }

    constructor(props) {
        super(props)
        this.Control = createControlFactory(ActionCreators.updateUser)
    }

    _toggleAdditionalPhone = () => {
        this.setState({
            hasAdditionalPhone: !this.state.hasAdditionalPhone,
        })
        ActionCreators.updateUser({
            phone_additional: '+',
        })
    }

    _pushErrorsToGa = (error) => {

        var prefix = 'noreg'
        if (this.state.user.has_account.value) {
            prefix = 'reg'
        }

        for (var name in error) {
            ga.event({
                category: 'fields',
                action: `booking_wrong_${name}_${prefix}`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onSubmitClick = () => {
        ActionCreators.showLoadingOverlay();

        if (this.state.user.has_account.value) {
            if (this.state.isPhoneOrMail) {
                ActionCreators.updateUser({
                    email: '',
                });
            } else {
                ActionCreators.updateUser({
                    phone_mobile: '',
                });
            }
        }

        UserStore.validate().then(
            done => {
                ActionCreators.sendUserToGa()

                // Disable instant prices mode
                ActionCreators.setInstantBookingPrice(0)

                UserStore.submit().then(response => {

                    if (window.ym) {
                        window.ym('1315865', 'reachGoal', 'add_orders_new_s5');
                    }

                    ga.event({
                        category: 'clicks',
                        action: 'button_ship_cost',
                        label: this.props.selectedCategory.name,
                        value: 1,
                    })

                    if (this.state.isIsraelModeOn) {
                        ReactPixel.track('Lead', {});
                    }

                    if (this.state.showInstantBooking) {
                        if (response && response.oid && typeof window.ga === 'function') {
                            window.ga('set', 'dimension20', response.oid)
                            window.ga('send', 'event', {
                                eventCategory: 'orders',
                                eventAction: 'add_orders_new_s5_instant_auction',
                                eventLabel: this.props.selectedCategory.name,
                                eventValue: 1,
                            })
                        }

                        if (window.ym) {
                            window.ym('1315865', 'reachGoal', 'add_orders_new_s5_instant_auction');
                        }
                    }

                    // In widget mode
                    if (window.parent) {
                        window.parent.location.href = response.redirect_url
                    } else {
                        window.location.href = response.redirect_url
                    }
                }, (error) => {
                    ActionCreators.hideLoadingOverlay()

                    // Clear autologin hash, because It could be set for email, that shall not pass the validation.
                    // For example carrier's email.
                    if (UserStore.hasAutologinHash()) {
                        ActionCreators.setAutologinHash(undefined)
                    }

                    if (!error) {
                        dumpState()
                        alert(t('SOMETHING_WENT_WRONG'))
                    } else {
                        alert(t(error))
                    }
                })
            },
            error => {
                if (error.phone_mobile) {
                    this.setState({ phoneErrors: error.phone_mobile })
                }

                ActionCreators.hideLoadingOverlay()
                this._pushErrorsToGa(error)
            },
        )
    }

    _onBack = () => {
        if (this.state.showInstantBooking) {
            ga.event({
                category: 'instant_booking_buttons',
                action: 'return_s4_to_instant_booking_from_auction',
                label: this.props.selectedCategory.name,
                value: 1,
            })

            const stage = `/category/${this.props.selectedCategory.name}/instant`
            ActionCreators.setStage(stage, this.props.location.query)
        } else {
            ga.event({
                category: 'buttons',
                action: 'click_button_return_s4_booking_step_5',
                label: this.props.selectedCategory.name,
                value: 1,
            })

            ActionCreators.setStage(`/category/${this.props.selectedCategory.name}/params`, this.props.location.query)
        }
    }

    _onChangeHasAccount = () => {
        ga.event({
            category: 'clicks',
            action: this.state.user.has_account.value ? 'registered' : 'non-registered',
            label: this.props.selectedCategory.name,
            value: 1,
        });

        ActionCreators.updateUser({
            isPhoneOrMail: false
        });
    }

    _onClickForgotPass = () => {

        this.setState({
            showRestorePasswordDialog: true,
        })

        ga.event({
            category: 'clicks',
            action: 'click_forgot_pass_booking_step_5',
            label: this.props.selectedCategory.name,
            value: 1,
        })
    }

    _onBlurNameInput = (event) => {

        var prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        if (event.target.value) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_name`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_name`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onBlurEmailInput = (event) => {

        var prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        if (event.target.value) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_email`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_email`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onBlurMobilePhoneInput = (phone) => {

        var prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        phone = phone.replace(/[\-\s]/g, "")

        if (phone && phone.length > 5) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_mobile`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_mobile`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onBlurAdditionalPhoneInput = (phone) => {

        var prefix = ''
        if (this.state.user.has_account.value) {
            prefix = 'reg_'
        }

        phone = phone.replace(/[\-\s]/g, "")

        if (phone && phone.length > 5) {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}fill_additional_phone`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: `contacts_${prefix}empty_additional_phone`,
                label: this.props.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onBlurPasswordInput = (event) => {

        if (event.target.value) {
            ga.event({
                category: 'fields',
                action: 'contacts_reg_fill_pass',
                label: this.props.selectedCategory.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'fields',
                action: 'contacts_reg_empty_pass',
                label: this.props.selectedCategory.name,
                value: 1,
            })
        }
    }

    _onClickSocialAuth = (socialType) => {
        this.setState({
            showSocialAuthDialog: true,
            socialAuthType: socialType,
        })

        ga.event({
            category: 'buttons',
            action: `auth_social_${socialType}`,
            label: this.props.selectedCategory.name,
            value: 1,
        })
    }

    _closeSocialAuthDialog = () => {
        this.setState({
            showSocialAuthDialog: false,
        })
    }

    _onSocialComplete = (userData, socialType) => {
        if (userData) {

            if (userData.autologin_hash) {
                ActionCreators.setAutologinHash(userData.autologin_hash)
            } else {
                // Clear autologin hash, because It could be set for email, that shall not pass the validation.
                // For example carrier's email.
                ActionCreators.setAutologinHash(undefined)
                ActionCreators.updateUser(userData)
            }

            ActionCreators.updateTmp({'social_net_type': socialType})

            this._onSubmitClick()
        }
    }

    _onCloseRestorePasswordDialog = () => {
        this.setState({
            showRestorePasswordDialog: false,
        })

        ActionCreators.setAutologinHash(undefined)
    }

    _onRestorePasswordComplete = (autologinHash) => {
        ActionCreators.setAutologinHash(autologinHash)
        this._onSubmitClick()
    }

    _onAgreeChange = (event, value) => {
        this.setState({
            agree: value,
        })
    }

    _toggleIsPhoneOrMail = () => {
        this.setState({
            isPhoneOrMail: !this.state.isPhoneOrMail,
        });
    }

    _onChangePhoneAuth = (e, phoneAuth) => {
        this.setState({ phoneAuth });

        ActionCreators.updateUser({
            phone_mobile: phoneAuth,
        });
    }

    render() {
        const hasAccount = this.state.user.has_account.value

        var hideName = ClassNames(
            'ContactsScreen-field',
            {'InputControl--hidden': hasAccount},
        )

        var hidePass = ClassNames({
            'InputControl--hidden': !hasAccount,
        })

        var hidePhones = ClassNames({
            'ContactsScreen-contactsPhones--hidden': hasAccount,
        })

        var additionalPhoneInputClasses = ClassNames(
            'ContactsScreen-otherPhone',
            {'InputControl--notVisible': !this.state.hasAdditionalPhone},
        )

        const user = this.state.user

        return (
            <div>

                {this.state.showSocialAuthDialog ?
                    <SocialAuthDialog
                        socialAuthType={this.state.socialAuthType}
                        onSocialComplete={this._onSocialComplete}
                        onClose={this._closeSocialAuthDialog}
                    /> : ''}

                {this.state.showRestorePasswordDialog ?
                    <RestorePasswordDialog
                        onRestorePasswordComplete={this._onRestorePasswordComplete}
                        onCloseDialog={this._onCloseRestorePasswordDialog}/> : ''}

                <div className="ContactsScreen container">
                    <div className="ContactsScreen-title">
                        Куда отправить информацию о ценах?
                    </div>
                    <div className="ContactsScreen-contacts">
                        <div className="ContactsScreen-mode">
                            <this.Control
                                type="switch"
                                onChange={this._onChangeHasAccount}
                                attribute={user.has_account}
                                checked={hasAccount}
                                size="m"
                                label="Я уже зарегистрирован"/>
                        </div>
                        {
                            hasAccount && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '20px',
                                    margin: '20px 0 20px 0',
                                }}>
                                    <span>Авторизация по почте</span>
                                    <this.Control
                                        type="switch"
                                        attribute={user.isPhoneOrMail}
                                        checked={this.state.isPhoneOrMail}
                                        onChange={this._toggleIsPhoneOrMail}
                                        size="m"
                                        label=""
                                    />
                                    <span>Авторизация по номеру</span>
                                </div>
                            )
                        }
                        <this.Control
                            id="username"
                            type="text"
                            attribute={user.name}
                            name="name"
                            required={true}
                            className={hideName}
                            onBlur={this._onBlurNameInput}
                            label="Ваше имя"/>
                        {
                            this.state.isPhoneOrMail
                                ? (
                                    <TelControl
                                        required
                                        onChange={this._onChangePhoneAuth}
                                        value={this.state.phoneAuth}
                                        label={'Телефон грузоотправителя'}
                                        placeholder={'Телефон грузоотправителя'}
                                        error={this.state.phoneErrors}
                                    />
                                )
                                : (
                                    <this.Control
                                        id="user_email"
                                        type="text"
                                        attribute={user.email}
                                        name="email"
                                        required={true}
                                        className="ContactsScreen-field"
                                        onBlur={this._onBlurEmailInput}
                                        label="Электронный адрес"
                                        htmlType="email"
                                    />
                                )
                        }
                        <div className={hidePass}>
                            <this.Control
                                id="user_password"
                                type="text"
                                attribute={user.password}
                                name="password"
                                required={true}
                                className="ContactsScreen-field"
                                label="Пароль"
                                onBlur={this._onBlurPasswordInput}
                                htmlType="password"/>
                            <div className="ContactsScreen-contactsForgotPassBox">
                                <a className="ContactsScreen-contactsForgotPass"
                                   href="javascript:;"
                                   onClick={this._onClickForgotPass}>
                                    Я забыл пароль
                                </a>
                            </div>
                        </div>
                        <div className={`ContactsScreen-contactsPhones ${hidePhones}`}>
                            <this.Control
                                required={true}
                                type="tel"
                                attribute={user.phone_mobile}
                                name="phone_mobile"
                                className="ContactsScreen-field ContactsScreen-phone"
                                onBlur={this._onBlurMobilePhoneInput}
                                isIsraelModeOn={this.state.isIsraelModeOn}
                                label="Мобильный телефон"/>
                            <div className="ContactsScreen-additionalPhoneBlock">
                                <Switch
                                    size="s"
                                    labelPos="top"
                                    label="Дополнительный телефон"
                                    onChange={this._toggleAdditionalPhone}
                                    className="ContactsScreen-additionalPhoneSwitch">
                                </Switch>
                                <this.Control
                                    type="tel"
                                    attribute={user.phone_additional}
                                    name="phone_additional"
                                    value={user.phone_additional.value}
                                    onBlur={this._onBlurAdditionalPhoneInput}
                                    className={additionalPhoneInputClasses}/>
                            </div>
                            <div className="ContactsScreen-contactsTip">
                                <p className="ContactsScreen-contactsTipText">
                                    Номер телефона необходим только в случае, если вас устроит цена и вы захотите
                                    заказать перевозку.
                                </p>
                                <IconSVG className="ContactsScreen-contactsTipSign"
                                         src={require('!svg-inline!./VeriSignTrusted.svg')}/>
                            </div>
                            <CheckboxControl className="ContactsScreen-agree"
                                             value={this.state.agree}
                                             label={<span>Согласен с обработкой моих персональных данных в соответствии с <a
                                                 href="/privacy_policy" target="_blank">политикой конфиденциальности</a></span>}
                                             onChange={this._onAgreeChange}/>
                        </div>
                    </div>
                    <div className="ContactsScreen-rightBlock">
                        {!this.state.isIsraelModeOn ?
                            <div className="ContactsScreen-social">
                                <p className="ContactsScreen-socialTitle">Или присоединитесь через</p>
                                <div className="ContactsScreen-socialTabs">
                                    <div className="ContactsScreen-socialTab"
                                         onClick={this._onClickSocialAuth.bind(this, 'mailru')}>
                                        <IconSVG className="ContactsScreen-socialTabIcon"
                                                 src={require('!svg-inline!./social/mailru.svg')}/>
                                    </div>
                                    <div className="ContactsScreen-socialTab"
                                         onClick={this._onClickSocialAuth.bind(this, 'yandex')}>
                                        <IconSVG className="ContactsScreen-socialTabIcon"
                                                 src={require('!svg-inline!./social/ya.svg')}/>
                                    </div>
                                    <div className="ContactsScreen-socialTab"
                                         onClick={this._onClickSocialAuth.bind(this, 'google')}>
                                        <IconSVG className="ContactsScreen-socialTabIcon"
                                                 src={require('!svg-inline!./social/google.svg')}/>
                                    </div>
                                    {/*<div className="ContactsScreen-socialTab"
                                         onClick={this._onClickSocialAuth.bind(this, 'ok')}>
                                        <IconSVG className="ContactsScreen-socialTabIcon"
                                                 src={require('!svg-inline!./social/ok.svg')}/>
                                    </div>*/}
                                    {/*<div className="ContactsScreen-socialTab"
                                         onClick={this._onClickSocialAuth.bind(this, 'vk')}>
                                        <IconSVG className="ContactsScreen-socialTabIcon"
                                                 src={require('!svg-inline!./social/vk.svg')}/>
                                    </div>*/}
                                    {/*<div className="ContactsScreen-socialTab"
                                         onClick={this._onClickSocialAuth.bind(this, 'facebook')}>
                                        <IconSVG className="ContactsScreen-socialTabIcon"
                                                 src={require('!svg-inline!./social/fb.svg')}/>
                                    </div>*/}
                                </div>
                            </div> : <div className="ContactsScreen-social"></div> }
                            {!this.state.isIsraelModeOn ?
                                <div className="ContactsScreen-guarantees">
                                    <IconSVG className="ContactsScreen-FZ152"
                                             src={require('!svg-inline!./FZ152.svg')}/>
                                    <p className="ContactsScreen-guaranteesText">Сервис «Везет Всем» внесен в реестр операторов
                                        персональных данных Роскомнадзора и полностью соответствует требованиям 152-ФЗ «О
                                        персональных данных»</p>
                                </div> : <div className="ContactsScreen-guarantees"></div>}
                    </div>
                </div>
                <div className="container">
                    <div className="ContactsScreen-controls">
                        <Button
                            className="ContactsScreen-controls-back"
                            view="stone"
                            size="s"
                            leftIcon={LEFT_BUTTON_ARROW}
                            onClick={this._onBack}>
                            Назад
                        </Button>
                        <Button
                            className="ContactsScreen-controls-next"
                            view="sand"
                            size="m"
                            onClick={this._onSubmitClick}
                            disabled={!this.state.user.has_account.value && !this.state.agree}>
                            Узнать стоимость перевозки
                        </Button>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <ProgressBarPane linkActive={CONTACTS_SCREEN_PROGRESS_BAR_CONFIG} location={this.props.location}/>
            </div>
        )
    }

}

export default ContactsScreen



// WEBPACK FOOTER //
// ./client/components/ContactsScreen/ContactsScreen.js